export default __webpack_public_path__ + "static/media/Science.d446c2ab.png";